import * as i0 from '@angular/core';
import { NgModule, Injectable, Inject } from '@angular/core';
import { BehaviorSubject, of } from 'rxjs';
import { switchMap, map, tap } from 'rxjs/operators';
import * as i1 from '@angular/common/http';

class AnbNgMapConfigManagerModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.7", ngImport: i0, type: AnbNgMapConfigManagerModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.7", ngImport: i0, type: AnbNgMapConfigManagerModule }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.7", ngImport: i0, type: AnbNgMapConfigManagerModule }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.7", ngImport: i0, type: AnbNgMapConfigManagerModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [],
                    imports: [],
                    exports: [],
                }]
        }] });

class ConfigManagerService {
    constructor(configPath, http) {
        this.configPath = configPath;
        this.http = http;
        this.configSrc = new BehaviorSubject(null);
        this.configurations$ = this.configSrc.asObservable();
        /**
         * Get all configuration at config file
         * @returns Observable<Config[]>
         */
        this.getConfigurations = () => this.configurations$.pipe(switchMap((configs) => {
            if (configs?.length) {
                return of(configs);
            }
            return this.http.get(this.configPath).pipe(map((response) => response.config), tap((c) => this.configSrc.next(c)));
        }));
    }
    /**
     * Retuns the configuration object filtered on target property
     * @returns Observable<Config>
     */
    getConfiguration(target) {
        return this.getConfigurations().pipe(map((configs) => configs.find((f) => f?.mapConfigOptions?.target === target)));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.7", ngImport: i0, type: ConfigManagerService, deps: [{ token: 'LEGEND_MANAGER_ENDPOINT' }, { token: i1.HttpClient }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.7", ngImport: i0, type: ConfigManagerService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.7", ngImport: i0, type: ConfigManagerService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: ['LEGEND_MANAGER_ENDPOINT']
                }] }, { type: i1.HttpClient }]; } });

/** Map Legends Configuration */
class Config {
}

/** For use with ARCGIS query legends services. */
class QueryLegendConfigOptions {
    constructor() {
        /** debounce timeout when changing the extent */
        this.debounceTime = 250;
        /** Label icon size */
        this.size = 100;
        /** Show only labels that are visible on the map */
        this.visibleOnly = true;
        /** Make the background transparent */
        this.backgroundTransparent = false;
    }
}

var LegendTypeEnum;
(function (LegendTypeEnum) {
    LegendTypeEnum["ARCGIS"] = "ARCGIS";
    LegendTypeEnum["CUSTOM"] = "CUSTOM";
    LegendTypeEnum["WMS"] = "WMS";
    LegendTypeEnum["WMTS"] = "WMTS";
    LegendTypeEnum["NONE"] = "NONE";
})(LegendTypeEnum || (LegendTypeEnum = {}));

/*
 * Public API Surface of anb-ng-map-config-manager
 */

/**
 * Generated bundle index. Do not edit.
 */

export { AnbNgMapConfigManagerModule, Config, ConfigManagerService, LegendTypeEnum, QueryLegendConfigOptions };
